import * as Sentry from "@sentry/browser";
import { FranchiseStatusInitialState } from "../../../services/redux/slices/franchiseStatusSlice";
import { setAmplitudeIdentify } from "../../amplitude";
import { getCookie } from "../../CookieHelper";
import { COOKIE_ENUM } from "../../enums";
import { validatePhoneNumber } from "../../phoneNumberHelp";
import { tokenPayload } from "../../types";
import * as userHelper from "./user";

export function isVisitor() {
  const token = getCookie(COOKIE_ENUM.TOKEN);
  if (token && token?.length > 0) {
    const decodedToken = userHelper.parseJwt(token);

    if (decodedToken && decodedToken[COOKIE_ENUM.VISITOR]) {
      return true;
    } else {
      return false;
    }
  }

  return true;
}

export function acceptedTermsAndConditions() {
  const token = getCookie(COOKIE_ENUM.TOKEN);
  if (token && token?.length > 0) {
    const decodedToken = userHelper.parseJwt(token);

    if (decodedToken && decodedToken[COOKIE_ENUM.VISITOR]) {
      return true;
    } else {
      return false;
    }
  }

  return true;
}

export function monitoringIdentifiers(token: string, receiptId?: number) {
  const decodedToken = userHelper.parseJwt(token);
  if (decodedToken && decodedToken.customer_id) {
    Sentry.setUser({
      id: decodedToken.customer_id,
    });
    try {
      // Amplitude Session Replay tracking
      console.log("setAmplitudeIdentifyProperties");
      setAmplitudeIdentify({
        receiptId: receiptId ? receiptId.toString() : "undefined",
      });
    } catch (e) {
      console.log("monitoringIdentifiers identification error ", e);
    }
  }
}

export function getCurrentTokenCustomerId() {
  const token = getCookie(COOKIE_ENUM.TOKEN);
  if (token && token?.length > 0) {
    const decodedToken = userHelper.parseJwt(token);

    if (decodedToken && decodedToken.customer_id) {
      return Number(decodedToken.customer_id);
    }
  }

  return undefined;
}

// HELPER
export function parseJwt(token: string | undefined): tokenPayload | undefined {
  try {
    const base64Url = token?.split(".")[1];
    if (base64Url) {
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        window
          .atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );

      return JSON.parse(jsonPayload);
    }
  } catch (error) {
    return undefined;
  }
}

export function isSelfServiceWithoutSignIn(
  franchiseStatus: FranchiseStatusInitialState
) {
  const isVisitor = userHelper.isVisitor();

  return (
    isVisitor &&
    franchiseStatus.selfService &&
    franchiseStatus.selfServiceWithoutSignIn
  );
}

export const getQrCodeData = (token: string | undefined, offerId?: number) => {
  const userInfo = parseJwt(token);

  const phoneNumberData = validatePhoneNumber(userInfo?.phone_number ?? "");

  const qrCodeData = {
    customer_name: userInfo?.person_name,
    customer_mobile_number: phoneNumberData.formattedNumber,
    mobile_country_code: Number(phoneNumberData.countryCallingCode),
  };

  if (offerId) {
    return {
      ...qrCodeData,
      reward_code: offerId.toString(),
    };
  }

  return qrCodeData;
};
